import { Stack } from '@mui/material';
import { FC, useMemo, useState } from 'react';
import ScrollBox from '@/components/scroll-box';
import SearchInput from '@/components/search-input';
import useUserSettings from '@/hooks/use-user-settings.hook';
import AgentBadge from '@/components/agent-badge';
import UserSettingsCard from './card';
import CardOpt from './card-opt';
import CardDetail from './card-detail';

interface Props {
  max: number;
}

const AgentCard: FC<Props> = ({ max }) => {
  const [keyword, setKeyword] = useState('');
  const { agents, isLoading, threadSettings, setAgentId } = useUserSettings();
  const { agentId } = threadSettings;

  const filteredAgents = useMemo(() => {
    const safeKeyword = String(keyword).trim().toLowerCase();
    return agents.filter(({ portal }) => {
      const {
        badge: { title },
      } = portal;
      return String(title).toLowerCase().includes(safeKeyword);
    });
  }, [agents, keyword]);

  const hasAgents = !!filteredAgents.length;
  const showEmptyMessage = !isLoading && !hasAgents;
  const emptyMessage = keyword ? 'No assistants found' : 'No assistants available';

  return (
    <UserSettingsCard title="Assistants" loading={isLoading}>
      <CardDetail>Choose the assistant to use when creating a new conversation.</CardDetail>
      <Stack direction="row" justifyContent="space-between" alignItems="center" className="toolbar">
        <SearchInput
          value={keyword}
          onChange={setKeyword}
          placeholder="Search by name"
          disableHideInput
        />
      </Stack>
      <ScrollBox max={max} emptyMessage={showEmptyMessage ? emptyMessage : ''} selected={agentId}>
        {filteredAgents.map((agent) => {
          const { id, badgeTitle } = agent;
          const selected = id === agentId;
          const IconEl = <AgentBadge agent={agent} size="small" />;

          return (
            <CardOpt
              id={id}
              name={badgeTitle}
              selected={selected}
              onChange={setAgentId}
              key={id}
              IconEl={IconEl}
            />
          );
        })}
      </ScrollBox>
    </UserSettingsCard>
  );
};

export default AgentCard;
